// extracted by mini-css-extract-plugin
module.exports = {"root":"CardReaderDesc_root__shBg8","col":"CardReaderDesc_col__2gdJB","label":"CardReaderDesc_label__bJqjm"};